import { Link } from "@tanstack/react-router";
import MDXRemote from "#/components/MdxRemote";
import { toAppPath } from "#/lib/router-links";
import type { HiringOrg } from "#/types/types";
import YoutubeVideo from "../YoutubeVideo";

export default function EmployerAbout({
  hiringOrg,
}: {
  hiringOrg: HiringOrg | null;
}) {
  if (hiringOrg)
    return (
      <section className="mx-5 space-y-3 pt-10">
        <h2 className="mb-5 mt-10 text-xl text-sky-600">
          Who is hiring? {hiringOrg.name}
        </h2>

        <MDXRemote source={hiringOrg.aboutJobPosting} />

        <div>
          <Link {...toAppPath("/jobs-at-" + hiringOrg.slug)}>
            {`View all jobs at ${hiringOrg.name} in ${hiringOrg.stateName}`}
          </Link>
        </div>

        {hiringOrg.youtubeVideoId?.trim().length && (
          <div className="pt-10">
            <YoutubeVideo videoId={hiringOrg.youtubeVideoId} />
          </div>
        )}
      </section>
    );

  return null;
}
